<div class="sc-dialog-wrapper" style="width: 480px">
  <div class="m3-dialog-header">
    <h2 class="m3-dialog-headline">
      {{ 'certificate_fields_dialog_title' | translate }}
    </h2>
  </div>
  <div
    mat-dialog-content
    style="--mdc-dialog-supporting-text-color: var(--md-sys-color-on-surface)"
  >
    <div class="r__container">
      @if (form) {
        <section class="r__middle" [formGroup]="form">
          @if (fields) {
            <div
              class="grid grid-align-items-start"
              style="row-gap: var(--md-sys-size-5)"
            >
              @for (field of fields; track $index) {
                @switch (field.field_type) {
                  @case ('select') {
                    <mat-form-field
                      [class.sm-col-span-6]="fields.length > 3"
                      appearance="outline"
                    >
                      <mat-label>{{ field.label | translate }}</mat-label>
                      <mat-select
                        [required]="field.is_required === true"
                        [formControlName]="field.field_key"
                      >
                        @for (data of field.data; track $index) {
                          <mat-option [value]="data.key">{{
                            data.label | translate
                          }}</mat-option>
                        }
                      </mat-select>
                      <mat-error
                        *ngIf="form.controls[field.field_key].invalid"
                        >{{
                          'please_fill_in_this_required_field' | translate
                        }}</mat-error
                      >
                      <button
                        *ngIf="field.description"
                        mat-icon-button
                        matSuffix
                        [matTooltip]="field.description"
                      >
                        <mat-icon>info</mat-icon>
                      </button>
                    </mat-form-field>
                  }
                  @case ('text') {
                    <mat-form-field
                      [class.sm-col-span-6]="fields.length > 3"
                      appearance="outline"
                    >
                      <mat-label>{{ field.label | translate }}</mat-label>
                      <input
                        matInput
                        [required]="field.is_required === true"
                        [formControlName]="field.field_key"
                      />
                      <mat-error
                        *ngIf="form.controls[field.field_key].invalid"
                        >{{
                          'please_fill_in_this_required_field' | translate
                        }}</mat-error
                      >
                      <button
                        *ngIf="field.description"
                        mat-icon-button
                        matSuffix
                        [matTooltip]="field.description"
                      >
                        <mat-icon>info</mat-icon>
                      </button>
                    </mat-form-field>
                  }
                  @case ('date') {
                    <mat-form-field [class.sm-col-span-6]="fields.length > 3">
                      <mat-label>{{ field.label | translate }}</mat-label>
                      <input
                        matInput
                        [matDatepicker]="picker"
                        [formControlName]="field.field_key"
                        [required]="field.is_required === true"
                        (dateChange)="dateFormat($event, field)"
                      />
                      <mat-error
                        *ngIf="form.controls[field.field_key].invalid"
                        >{{
                          'please_fill_in_this_required_field' | translate
                        }}</mat-error
                      >
                      <mat-hint class="text-muted">TT/MM/JJJJ</mat-hint>
                      <mat-datepicker-toggle
                        matIconSuffix
                        [for]="picker"
                      ></mat-datepicker-toggle>
                      <mat-datepicker #picker></mat-datepicker>
                      <button
                        *ngIf="field.description"
                        mat-icon-button
                        matSuffix
                        [matTooltip]="field.description"
                      >
                        <mat-icon>info</mat-icon>
                      </button>
                    </mat-form-field>
                  }
                  @case ('email') {
                    <mat-form-field
                      [class.sm-col-span-6]="fields.length > 3"
                      appearance="outline"
                    >
                      <mat-label>{{ field.label | translate }}</mat-label>
                      <input
                        matInput
                        [required]="field.is_required === true"
                        [formControlName]="field.field_key"
                      />
                      <mat-error
                        *ngIf="form.controls[field.field_key].invalid"
                        >{{
                          'please_fill_in_this_required_field' | translate
                        }}</mat-error
                      >
                      <button
                        *ngIf="field.description"
                        mat-icon-button
                        matSuffix
                        [matTooltip]="field.description"
                      >
                        <mat-icon>info</mat-icon>
                      </button>
                    </mat-form-field>
                  }
                  @case ('checkbox') {
                    <div>
                      <mat-checkbox
                        color="primary"
                        [required]="field.is_required === true"
                        [formControlName]="field.field_key"
                      >
                        <span
                          [ngClass]="{
                            'text-danger':
                              form.controls[field.field_key].invalid &&
                              form.controls[field.field_key].touched,
                          }"
                        >
                          {{ field.label | translate }}
                          @if (field.is_required) {
                            *
                          }
                        </span>
                      </mat-checkbox>
                    </div>
                  }
                }
              }
            </div>
          }
        </section>
      }
    </div>
  </div>
  <div mat-dialog-actions>
    <button mat-button color="primary" (click)="close()">
      {{ 'Cancel' | translate }}
    </button>
    <button mat-button color="primary" (click)="save()">
      {{ 'download_certificate' | translate }}
    </button>
  </div>
</div>
